(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /*
    Warm the Pokemon submenu icons after the important page work is complete.

    The icon URLs are read from each link's CSS ::before rule, so this remains
    automatic when new menu items and icon rules are added later. Keeping the
    Image objects in a shared array prevents them from being discarded before
    their requests finish.
  */
  (() => {
    const desktopQuery = window.matchMedia('(min-width: 990px)');
    const iconSelector = '[id^="HeaderMenu-pokemon-singles-"]';
    const cachedImages = [];
    let hasStarted = false;

    const preloadPokemonMenuIcons = () => {
      if (hasStarted || !desktopQuery.matches) return;
      hasStarted = true;

      const urls = new Set();

      document.querySelectorAll(iconSelector).forEach((link) => {
        const backgroundImage = window.getComputedStyle(link, '::before').backgroundImage;

        if (!backgroundImage || backgroundImage === 'none') return;

        /*
          A background may contain more than one layer. Extract every url()
          value while leaving gradients and other CSS functions alone.
        */
        for (const match of backgroundImage.matchAll(/url\((['"]?)(.*?)\1\)/g)) {
          if (match[2]) urls.add(match[2]);
        }
      });

      urls.forEach((url) => {
        const image = new Image();
        image.decoding = 'async';
        image.src = url;
        cachedImages.push(image);
      });
    };

    const scheduleIdlePreload = () => {
      if (!desktopQuery.matches) return;

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(preloadPokemonMenuIcons, { timeout: 2500 });
      } else {
        window.setTimeout(preloadPokemonMenuIcons, 1500);
      }
    };

    /*
      Pointer and keyboard intent get priority. This covers visitors who open
      the menu immediately, before the browser reaches its idle period.
    */
    const pokemonMenuTrigger = document.querySelector(
      '.header__inline-menu [id*="HeaderMenu-pokemon-singles"]'
    );

    pokemonMenuTrigger?.addEventListener('pointerenter', preloadPokemonMenuIcons, { once: true });
    pokemonMenuTrigger?.addEventListener('focusin', preloadPokemonMenuIcons, { once: true });

    if (document.readyState === 'complete') {
      scheduleIdlePreload();
    } else {
      window.addEventListener('load', scheduleIdlePreload, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
